import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "../../components/SectionHeading";
import { visionContent } from "./aboutContent";

const AboutVision = () => (
  <section
    className="bg-white py-14 lg:py-20"
    aria-labelledby="about-vision-heading"
  >
    <div className="sectionlayout">
      <SectionHeading
        id="about-vision-heading"
        title={visionContent.title}
        subtitle={visionContent.subtitle}
      />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="mx-auto max-w-3xl space-y-4 text-center"
      >
        {visionContent.paragraphs.map((paragraph) => (
          <p
            key={paragraph}
            className="text-sm md:text-base leading-relaxed text-gray-600"
          >
            {paragraph}
          </p>
        ))}
      </motion.div>
    </div>
  </section>
);

export default AboutVision;
